import { render, staticRenderFns } from "./SwitchAccountPopup.vue?vue&type=template&id=4c9ed905&scoped=true&"
import script from "./SwitchAccountPopup.vue?vue&type=script&lang=js&"
export * from "./SwitchAccountPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9ed905",
  null
  
)

export default component.exports